import { useContext } from 'react';

import { PropertyState } from 'services/rentals/objects/property';

export const usePropertyState = () => useContext(PropertyState);
